// extracted by mini-css-extract-plugin
export default {"title":"CStarsMembers_title_cd6b3","text":"CStarsMembers_text_fc8c0","clanMembersWrapper":"CStarsMembers_clanMembersWrapper_f56a9","clanMembers":"CStarsMembers_clanMembers_cb6f2"};